import React from "react";
import "./App.css";
import { Link, useHistory, withRouter, Redirect } from "react-router-dom";
import Axios from "axios";
import Footer from "./components/Footer";
import Header_ from "./components/Header";
import Header5 from "./components/Header5";
import { FaMoneyBillAlt } from "react-icons/fa";
import { IoMdBusiness } from "react-icons/io";
import { HiCursorClick } from "react-icons/hi";
import { BsAppIndicator, BsHouse } from "react-icons/bs";
import { SiMinutemailer } from "react-icons/si";
import Header from "./layouts/Header";

class Aboutkaramale extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    document.title = "About Karamale - Know more";
  }

  render() {
    return (
      <div className="view mt-5">
        {localStorage.getItem("partnerid") !== null ? <Header5 /> : <Header />}
        <div className="container">
          <div className="row justify-content-center just-container-insid">
            <div className="col-lg-10 mt-5 pl-0 pr-0">
              <div className=" BoxDashboardContainer mb-5 p-0">
                <div className="row align-self-center justify-content-center">
                  <div className="col-12 p-0">
                    <div className="karamale-banner row justify-content-center align-items-center">
                      <div className="col-12 text-center">
                        <h2 className="color-white">
                          <span>Selling tickets made easy</span>
                        </h2>
                        <label className="color-white">
                          Create and launch events. Start selling in minutes.
                        </label>
                        <br />
                        <Link to="/business">
                          <label className="become-an-affiliate-btn">
                            Sign up
                          </label>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className=" BoxDashboardContainer mb-5 pl-2 pr-2 pt-3">
                <div className="row align-self-center justify-content-center">
                  <div className="col-12">
                    <span className="">
                      <h3> About Karamale</h3>
                    </span>
                  </div>

                  <div className="h-divider w-100"></div>

                  <div className="item-selet">
                    <div className="col-12">
                      <label className="item-nam">
                        <span>
                          Karamale is a smart, user-friendly ticketing platform
                        </span>
                        that empowers event organisers, planners, and managers
                        to create, launch, and manage events while seamlessly
                        selling tickets online and offline.
                        <br />
                        <br />
                        <h5>
                          <span>Who is it for?</span>
                        </h5>
                        Karamale is built for{" "}
                        <span>anyone who hosts events</span> — from professional
                        planners and promoters to independent organisers. If
                        you're planning a show, conference, party, or gathering
                        and want to sell tickets,{" "}
                        <span>Karamale is your go-to solution.</span>
                        <br />
                        <br />
                        <p>
                          <span>Getting Started is Simple</span>
                        </p>
                        <ol>
                          <li>
                            <p>
                              <span>Sign up</span> as an organiser on{" "}
                              <a href="https://karamale.com">Karamale.com</a>
                            </p>
                          </li>
                          <li>
                            <p>
                              <span>Verify your account</span> using the secure
                              email code we send you
                            </p>
                          </li>
                          <li>
                            <p>
                              <span>Access your organiser dashboard</span> —
                              your personal command center
                            </p>
                          </li>
                        </ol>
                        <p>From your dashboard, you can:</p>
                        <ul>
                          <li>
                            <p>Create unlimited events</p>
                          </li>
                          <li>
                            <p>Set ticket prices</p>
                          </li>
                          <li>
                            <p>Track sales and payouts in real time</p>
                          </li>
                        </ul>
                        <p>
                          The system handles the heavy lifting — you just feed
                          it the details.
                        </p>
                        <p>
                          <h5>
                            <span>When Can I Create Events?</span>
                          </h5>
                        </p>
                        <p>
                          <span>Anytime. Anywhere.</span>
                        </p>
                        <p>
                          There are no time restrictions. Whether it’s midnight
                          or lunchtime,{" "}
                          <span>
                            you have full access to launch events when it suits
                            you.
                          </span>{" "}
                          All you need is a device and an internet connection.
                          You’re in control —{" "}
                          <span>we just make it seamless.</span>
                        </p>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <h5 className="mb-3">Join 100s of organisers</h5>
              <div className=" BoxDashboardContainer mb-5 pl-2 pr-2 pt-3">
                <div className="row align-self-center justify-content-center">
                  <div className="row">
                    <div className="col-lg-12 col-12 mb-4">
                      <div className="blocks-3 text-left snippet">
                        <h5>
                          <span>Sign Up Today</span>
                        </h5>
                        <p>
                          <span>Unlock your organisation’s potential.</span>{" "}
                          Join hundreds of event professionals already using
                          Karamale to create, launch, and manage successful
                          events.
                        </p>

                        <p>
                          Start selling tickets instantly — with the most
                          intuitive and powerful ticketing platform available.
                        </p>
                      </div>
                    </div>

                    <div className="col-lg-12 col-12 mb-4 ">
                      <div className="blocks-3 text-left snippet">
                        <h5>
                          <span>Your Karamale Dashboard</span>
                        </h5>
                        <p>
                          Gain full access to your personal organiser dashboard
                          — available anytime, anywhere.{" "}
                        </p>

                        <p>
                          This is your control centre — the place where ideas
                          become real events. From setting up tickets to
                          tracking sales and managing payouts,{" "}
                          <span>everything starts here.</span>
                        </p>

                        <p>All the tools you need, right at your fingertips.</p>
                      </div>
                    </div>

                    <div className="col-lg-12 col-12 mb-2">
                      <div className="blocks-3 text-left snippet">
                        <h5>
                          <span>Marketing Made Easy</span>
                        </h5>
                        <p>
                          Launch your event marketing campaign directly through
                          Karamale. Choose between <span>SMS</span> and{" "}
                          <span>Email marketing</span>, then select your
                          audience:
                        </p>
                        <ul>
                          <li>
                            <p>
                              Target your <span>existing contacts</span>
                            </p>
                          </li>
                          <li>
                            <p>
                              Reach the <span>Karamale network</span>
                            </p>
                          </li>
                          <li>
                            <p>
                              Or <span>upload your own custom list</span>
                            </p>
                          </li>
                        </ul>
                        <p>
                          Reach the right people, with the right message — all
                          in one place.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <h5 className="mb-3">
                With Karamale, possibilities are limitless
              </h5>
              <div className=" BoxDashboardContainer mb-5 pl-2 pr-2 pt-3">
                <div className="row align-self-center justify-content-center">
                  <div className="row">
                    <div className="col-lg-4 col-12 mb-4">
                      <div className="blocks-3">
                        <img
                          src="http://karamale.com/apps/kscanner/icons/dashboard.jpeg"
                          width={"100%"}
                        />
                        <br />
                        <br />
                        <span className="font-size-20">Dashboard</span>
                        <br />
                        Get all the features from your dashboard, this is your
                        gateway to all things you can do on Karamale.
                      </div>
                    </div>

                    <div className="col-lg-4 col-12 mb-4">
                      <div className="blocks-3">
                        <img
                          src="http://karamale.com/apps/kscanner/icons/createevent.jpeg"
                          width={"100%"}
                        />
                        <br />
                        <br />
                        <span className="font-size-20">Create an event</span>
                        <br />
                        In minutes; your event can be on the system and ready to
                        be listed for your audience to buy tickets.
                      </div>
                    </div>

                    <div className="col-lg-4 col-12 mb-4">
                      <div className="blocks-3">
                        <img
                          src="http://karamale.com/apps/kscanner/icons/eventlisted.jpeg"
                          width={"100%"}
                        />
                        <br />
                        <br />
                        <span className="font-size-20">Your listed event</span>
                        <br />
                        Your event will appear on the landing page, making it
                        open to your audience to explore and buy tickets.
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <h5 className="mb-3">All things Analytics</h5>
              <div className=" BoxDashboardContainer mb-5 pl-2 pr-2 pt-0">
                <div className="row align-self-center justify-content-center">
                  <div className="row">
                    <div className="col-lg-4 col-12 mb-4">
                      <div className="blocks-3">
                        <img
                          src="http://karamale.com/apps/kscanner/icons/revenue.jpeg"
                          width={"100%"}
                        />
                        <br />
                        <br />
                        <span className="font-size-20">Revenue</span>
                        <br />
                        Know your revenue, know how much you are making.
                        Karamale gives you access to all things analytics, with
                        sales revenue at your fingertips.
                      </div>
                    </div>

                    <div className="col-lg-4 col-12 mb-4">
                      <div className="blocks-3">
                        <img
                          src="http://karamale.com/apps/kscanner/icons/salesprogress.jpeg"
                          width={"100%"}
                        />
                        <br />
                        <br />
                        <span className="font-size-20">Sales progress</span>
                        <br />
                        Gain a clear view of your sales performance in real
                        time. Track how your team is doing, monitor total ticket
                        revenue, and see how many tickets are left. Understand
                        your income across each ticket category — all from one
                        powerful dashboard
                      </div>
                    </div>

                    <div className="col-lg-4 col-12 mb-4">
                      <div className="blocks-3">
                        <img
                          src="http://karamale.com/apps/kscanner/icons/performance.jpeg"
                          width={"100%"}
                        />
                        <br />
                        <br />
                        <span className="font-size-20">Performance</span>
                        <br />
                        Stay on top of your performance with real-time
                        analytics. Compare today’s sales with yesterday’s,
                        monitor your momentum, and assess how you’re performing
                        at a glance. With powerful insights at your fingertips,
                        you’ll always know exactly how your ticket sales are
                        trending.
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className=" BoxDashboardContainer mb-5 pl-2 pr-2 pt-3">
                <div className="row align-self-center justify-content-center">
                  <div className="item-selet">
                    <div className="col-12">
                      <label>
                        <p>
                          <span>What is a campaign?</span>
                        </p>
                        <p>
                          Karamale operates on a campaign-based model. As an
                          organiser, you can create events for free — but to
                          activate an event and make it available for ticket
                          sales, you'll need to launch a campaign for that
                          specific event.
                        </p>
                        <p>
                          Every campaign requires a budget, which acts as the
                          fuel for making your event live and visible.
                        </p>
                        <p>
                          <span>How Does the Budget Work?</span>
                        </p>
                        <p>
                          The budget is a prepaid amount you allocate to
                          Karamale when creating a campaign. Each time someone
                          buys a ticket to your event, Karamale deducts a 3.5%
                          service fee from your campaign budget — not from your
                          earnings.
                        </p>
                        <p>
                          This continues automatically with every sale until the
                          budget runs out.
                        </p>
                        <p>
                          Important: Your budget is the only payment you’ll ever
                          make to Karamale. All revenue generated from ticket
                          sales belongs entirely to you.
                        </p>
                        <p>
                          <span>What Does a Campaign Include?</span>
                        </p>
                        <p>
                          Your campaign doesn’t just activate your event — it
                          unlocks valuable insights and data, including:
                        </p>
                        <ul>
                          <li>
                            <p>Reach and Impressions</p>
                          </li>
                          <li>
                            <p>Ticket Admissions and Unique Buyers</p>
                          </li>
                          <li>
                            <p>Remaining Budget Balance</p>
                          </li>
                          <li>
                            <p>Total Expenditure</p>
                          </li>
                          <li>
                            <p>
                              And more real-time analytics to help you optimise
                              your performance
                            </p>
                          </li>
                        </ul>

                        <p>
                          <span>Why Organisers Choose Karamale</span>
                        </p>
                        <p>
                          Karamale is designed to be cost-effective and
                          transparent. There are no hidden fees — and we never
                          take a cut from your ticket revenue.
                        </p>
                        <p>
                          You’re free to start with any budget amount that suits
                          your needs — whether it’s R10 or more, you’re in
                          control. We’re committed to making Karamale not just
                          powerful in its technology, but also affordable and
                          flexible for every organiser.
                        </p>
                        <p>
                          Important: Your campaign budget is the only payment
                          you'll ever make to Karamale. Every cent you earn from
                          ticket sales is entirely yours.
                        </p>

                        <p>
                          <span>Activating Your Event</span>
                        </p>
                        <p>
                          To make your event live and available for ticket
                          sales, you’ll need to create and fund a campaign. Once
                          your budget is confirmed — based on your selected
                          campaign dates — your event is instantly listed for
                          buyers to start purchasing tickets.
                        </p>
                        <p>
                          <span>Working with Promoters</span>
                        </p>
                        <p>
                          Yes — Karamale fully supports promoter collaboration.
                        </p>
                        <p>As an organiser, you can:</p>
                        <ul>
                          <li>
                            <p>Create unique promoter accounts</p>
                          </li>
                          <li>
                            <p>Assign login credentials to each promoter</p>
                          </li>
                          <li>
                            <p>Let promoters sell tickets on your behalf</p>
                          </li>
                          <li>
                            <p>
                              Monitor sales per promoter, including ticket
                              count, income generated, and category-level
                              breakdown (e.g. General, VIP, VVIP)
                            </p>
                          </li>
                        </ul>
                        <p>
                          This gives you full visibility into how each promoter
                          is performing in real time.
                        </p>

                        <p>
                          <span>
                            Managing Inactive or Underperforming Promoters
                          </span>
                        </p>
                        <p>
                          Karamale gives you powerful tools to manage your team
                          effectively.
                        </p>
                        <p>
                          If a promoter is inactive or underperforming, you can:
                          <ul>
                            <li>
                              <p>
                                Deactivate their account to suspend access
                                (temporary and reversible)
                              </p>
                            </li>
                            <li>
                              <p>
                                Delete the account permanently if they no longer
                                serve your needs
                              </p>
                            </li>
                          </ul>
                          <p>
                            Note: Deleting a promoter account is irreversible.
                            If you think you might work with them again,
                            deactivation is the safer option.
                          </p>
                        </p>
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div className=" BoxDashboardContainer mb-5 pl-2 pr-2 pt-3">
                <div className="row align-self-center justify-content-center">
                  <div className="item-selet">
                    <div className="col-12">
                      <label>
                        <p>
                          <span>How Do I Scan Tickets?</span>
                        </p>
                        <p>
                          Karamale makes scanning tickets simple and
                          cost-effective with our dedicated mobile app. Download
                          it to your smartphone and instantly turn your device
                          into a powerful scanner — no need to buy or rent
                          expensive scanning hardware.
                        </p>
                        <p>
                          This aligns with our promise: Karamale is built to
                          reduce your costs without compromising performance.
                        </p>
                        <p>
                          Every scan is automatically tracked in real time,
                          giving you access to key attendance insights like:
                        </p>

                        <ul>
                          <li>
                            <p>Tickets scanned vs total tickets sold</p>
                          </li>
                          <li>
                            <p>Actual attendance vs no-shows</p>
                          </li>
                          <li>
                            <p>
                              Category-level admissions data (General, VIP,
                              VVIP)
                            </p>
                          </li>
                        </ul>
                        <p>
                          With Karamale, data becomes your superpower — enabling
                          you to evaluate event performance effortlessly.
                        </p>

                        <p>
                          <span>Say Goodbye to Fake Tickets</span>
                        </p>
                        <p>
                          Our scanning app ensures secure validation at every
                          entry point. Whether you’re scanning with one device
                          or multiple across different gates, the system keeps
                          everything in sync.
                        </p>

                        <ul>
                          <li>
                            <p>If the ticket is valid → ✅ Access granted</p>
                          </li>
                          <li>
                            <p>
                              If the ticket is fake or already scanned →
                              ❌ Access denied
                            </p>
                          </li>
                        </ul>
                        <p>
                          Each scan displays real-time ticket details —
                          category, holder name, and admission status — helping
                          your team make fast, informed decisions.
                        </p>
                        <p>
                          <span>Physical or Digital? We Support Both.</span>
                        </p>
                        <p>
                          Yes, Karamale fully supports both physical and digital
                          ticketing:
                        </p>
                        <ul>
                          <li>
                            <p>
                              🎟️ Printed tickets can be generated directly from
                              the system — just R1.00 per ticket
                            </p>
                          </li>
                          <li>
                            <p>
                              🌐 Digital tickets allow for full data capture:
                              name, email, phone number, and more
                            </p>
                          </li>
                        </ul>
                        <p>
                          While both formats are fully secured and scannable, we
                          highly recommend digital tickets for deeper insights
                          and a more connected experience.
                        </p>
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div className=" BoxDashboardContainer mb-5 p-0">
                <div className="row align-self-center justify-content-center">
                  <div className="col-12 p-0">
                    <div className="karamale-banner-bottom row justify-content-center align-items-center">
                      <div className="col-12 text-center">
                        <h2 className="color-white">
                          <span>
                            Create, launch and sell tickets right away
                          </span>
                        </h2>
                        <label className="color-white">
                          Easy and simple. 10 minutes is all you need.
                        </label>
                        <br />
                        <Link to="/business">
                          <label className="become-an-affiliate-btn">
                            Sign up
                          </label>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <Footer /> */}
      </div>
    );
  }
}

export default Aboutkaramale;
